<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        Quản lý Banner
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body" v-loading="loading">
        <b-row>
          <b-col md="12" class="mb-4">
            <b-card>
              <div slot="header">
                <span class="flag-icon flag-icon-vn mr-2 img-thumbnail border-0 flag-icon-custom"></span>
                <strong>Banner Tiếng Việt</strong>
              </div>
              
              <div class="banner-grid">
                <div
                  v-for="(id, index) in vi_banner.value"
                  :key="id"
                  class="banner-item-wrapper"
                  :class="{
                    'dragging': draggedIndex === index && draggedLang === 'vi',
                    'drag-over': dragOverIndex === index && draggedLang === 'vi'
                  }"
                  draggable="true"
                  @dragstart="dragStart($event, index, 'vi')"
                  @dragover.prevent="dragOver(index)"
                  @dragleave="dragLeave"
                  @drop="dragDrop(index, 'vi')"
                  @dragend="dragEnd"
                >
                  <div class="banner-thumbnail-card">
                    <div class="banner-order-badge">
                      <span>{{ index + 1 }}</span>
                    </div>
                    <img :src="imgUrl + id" alt="Banner Tiếng Việt" class="banner-img" />
                    
                    <div class="banner-overlay">
                      <div class="drag-handle mb-2">
                        <i class="el-icon-rank"></i> Kéo để di chuyển
                      </div>
                      <el-button
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        size="medium"
                        @click="deleteImage(index, 'vi')"
                        title="Xóa banner"
                      >
                      </el-button>
                    </div>
                  </div>
                </div>

                <div class="banner-item-wrapper">
                  <el-upload
                    action=""
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="(file) => handleUpload(file, 'vi')"
                    accept="image/*"
                    multiple
                    class="banner-uploader"
                  >
                    <div class="banner-uploader-dragzone d-flex flex-column align-items-center justify-content-center">
                      <i class="el-icon-picture-outline text-info mb-2" style="font-size: 32px;"></i>
                      <span class="text-info font-weight-bold">Thêm ảnh Tiếng Việt</span>
                      <span class="text-muted small mt-1">Định dạng JPG, PNG, JPEG</span>
                    </div>
                  </el-upload>
                </div>
              </div>
            </b-card>
          </b-col>

          <b-col md="12" class="mb-4">
            <b-card>
              <div slot="header">
                <span class="flag-icon flag-icon-us mr-2 img-thumbnail border-0 flag-icon-custom"></span>
                <strong>Banner Tiếng Anh</strong>
              </div>
              
              <div class="banner-grid">
                <div
                  v-for="(id, index) in en_banner.value"
                  :key="id"
                  class="banner-item-wrapper"
                  :class="{
                    'dragging': draggedIndex === index && draggedLang === 'en',
                    'drag-over': dragOverIndex === index && draggedLang === 'en'
                  }"
                  draggable="true"
                  @dragstart="dragStart($event, index, 'en')"
                  @dragover.prevent="dragOver(index)"
                  @dragleave="dragLeave"
                  @drop="dragDrop(index, 'en')"
                  @dragend="dragEnd"
                >
                  <div class="banner-thumbnail-card">
                    <div class="banner-order-badge">
                      <span>{{ index + 1 }}</span>
                    </div>
                    <img :src="imgUrl + id" alt="Banner Tiếng Anh" class="banner-img" />
                    
                    <div class="banner-overlay">
                      <div class="drag-handle mb-2">
                        <i class="el-icon-rank"></i> Kéo để di chuyển
                      </div>
                      <el-button
                        type="danger"
                        icon="el-icon-delete"
                        circle
                        size="medium"
                        @click="deleteImage(index, 'en')"
                        title="Xóa banner"
                      >
                      </el-button>
                    </div>
                  </div>
                </div>

                <div class="banner-item-wrapper">
                  <el-upload
                    action=""
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="(file) => handleUpload(file, 'en')"
                    accept="image/*"
                    multiple
                    class="banner-uploader"
                  >
                    <div class="banner-uploader-dragzone d-flex flex-column align-items-center justify-content-center">
                      <i class="el-icon-picture-outline text-info mb-2" style="font-size: 32px;"></i>
                      <span class="text-info font-weight-bold">Thêm ảnh Tiếng Anh</span>
                      <span class="text-muted small mt-1">Định dạng JPG, PNG, JPEG</span>
                    </div>
                  </el-upload>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>

        <div class="text-center mt-3">
          <el-button
            type="info"
            plain
            v-ladda
            :loading="saving"
            @click="saveConfigs"
          >
            Lưu cấu hình
          </el-button>
          <el-button
            type="info"
            plain
            :disabled="saving"
            @click="getConfigs"
          >
            Hủy
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import ExtensionService from "../../../service/ExtensionService";
import mushroom from "../../../service/api/dulich-api";
import { blockUi, unblockUi } from "../../../shared/global";

export default {
  name: "QuanLyBannerList",
  data() {
    return {
      aLang: LanguageService.lang,
      imgUrl: ExtensionService.urlImg,
      loading: false,
      saving: false,
      vi_banner: {
        id: null,
        code: "vi_banner",
        value: [],
        roles: ["Admin", "Officer", "*"]
      },
      en_banner: {
        id: null,
        code: "en_banner",
        value: [],
        roles: ["Admin", "Officer", "*"]
      },
      draggedIndex: null,
      draggedLang: null,
      dragOverIndex: null
    };
  },
  created() {
    this.getConfigs();
  },
  methods: {
    async getConfigs() {
      this.loading = true;
      try {
        const response = await mushroom.config.listAsync({
          filters: "code:in:vi_banner,en_banner"
        });

        this.vi_banner.id = null;
        this.vi_banner.value = [];
        this.en_banner.id = null;
        this.en_banner.value = [];

        if (response && response.result) {
          ["vi_banner", "en_banner"].forEach(code => {
            const config = response.result.find(x => x.code === code);
            const lang = code.split("_")[0];
            const stateObj = this[`${lang}_banner`];
            if (config) {
              stateObj.id = config.id;
              try {
                stateObj.value = JSON.parse(config.value || "[]");
              } catch (e) {
                stateObj.value = config.value ? config.value.split(",").filter(Boolean) : [];
              }
            }
          });
        }
      } catch (error) {
        console.error("Lỗi khi tải cấu hình banner:", error);
        toastr.error("Không thể tải thông tin cấu hình du lịch.");
      } finally {
        this.loading = false;
      }
    },

    async saveConfigs() {
      this.saving = true;
      try {
        const langs = ["vi", "en"];
        for (const lang of langs) {
          const stateObj = this[`${lang}_banner`];
          const payload = {
            code: `${lang}_banner`,
            value: JSON.stringify(stateObj.value),
            roles: ["Admin", "Officer", "*"]
          };
          if (stateObj.id) {
            payload.id = stateObj.id;
            await mushroom.config.partialUpdateAsync(payload);
          } else {
            const res = await mushroom.config.createAsync(payload);
            if (res && res.result) {
              stateObj.id = res.result;
            }
          }
        }
        toastr.success("Lưu cấu hình banner thành công!");
        this.getConfigs();
      } catch (error) {
        console.error("Lỗi khi lưu cấu hình banner:", error);
        toastr.error("Lỗi khi lưu cấu hình banner.");
      } finally {
        this.saving = false;
      }
    },

    async handleUpload(file, lang) {
      if (file.raw.type !== "image/jpeg" && file.raw.type !== "image/png" && file.raw.type !== "image/jpg") {
        toastr.info("Vui lòng tải lên ảnh định dạng JPEG, JPG hoặc PNG.");
        return;
      }

      blockUi();
      try {
        const res = await mushroom.$file.uploadAsync({
          file: file.raw,
          name: file.name,
          tags: ["Banner"]
        });
        if (res && res.result) {
          this[`${lang}_banner`].value.push(res.result);
          toastr.success("Tải lên ảnh thành công!");
        }
      } catch (error) {
        console.error("Lỗi upload file:", error);
        toastr.error("Lỗi tải ảnh lên.");
      } finally {
        unblockUi();
      }
    },

    deleteImage(index, lang) {
      this.$confirm("Bạn có chắc chắn muốn xóa ảnh banner này?", "Xác nhận xóa", {
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Hủy",
        type: "warning"
      })
        .then(() => {
          this[`${lang}_banner`].value.splice(index, 1);
          toastr.success("Đã gỡ ảnh ra khỏi danh sách.");
        })
        .catch(() => {});
    },

    dragStart(event, index, lang) {
      this.draggedIndex = index;
      this.draggedLang = lang;
      event.dataTransfer.effectAllowed = "move";
    },
    dragOver(index) {
      this.dragOverIndex = index;
    },
    dragLeave() {
      this.dragOverIndex = null;
    },
    dragDrop(index, lang) {
      if (this.draggedLang !== lang || this.draggedIndex === null) return;
      const fromIndex = this.draggedIndex;
      const toIndex = index;

      if (fromIndex !== toIndex) {
        const list = this[`${lang}_banner`].value;
        const movedItem = list.splice(fromIndex, 1)[0];
        list.splice(toIndex, 0, movedItem);
        toastr.info("Thay đổi thứ tự hiển thị banner.");
      }
      this.dragEnd();
    },
    dragEnd() {
      this.draggedIndex = null;
      this.draggedLang = null;
      this.dragOverIndex = null;
    }
  }
};
</script>

<style scoped>
.flag-icon-custom {
  width: 24px;
  height: 16px;
  object-fit: cover;
  vertical-align: middle;
}

.banner-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 15px;
}

.banner-item-wrapper {
  position: relative;
  aspect-ratio: 16 / 9;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.banner-item-wrapper.dragging {
  opacity: 0.4;
  transform: scale(0.95);
}
.banner-item-wrapper.drag-over {
  transform: scale(1.03);
  box-shadow: 0 8px 16px rgba(23, 162, 184, 0.25);
  border: 2px dashed #17a2b8;
  border-radius: 4px;
}

.banner-thumbnail-card {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid #e4e7ed;
  background-color: #f5f7fa;
}

.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.25s ease-in-out;
  cursor: grab;
}
.banner-thumbnail-card:hover .banner-overlay {
  opacity: 1;
}
.banner-overlay:active {
  cursor: grabbing;
}

.drag-handle {
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  pointer-events: none;
}

.banner-order-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  background-color: #17a2b8;
  color: white;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 11px;
  z-index: 2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.banner-uploader {
  width: 100%;
  height: 100%;
}
::v-deep .banner-uploader .el-upload {
  width: 100%;
  height: 100%;
  display: block;
}
.banner-uploader-dragzone {
  width: 100%;
  height: 100%;
  border: 2px dashed #dcdfe6;
  border-radius: 4px;
  background-color: #fafafa;
  cursor: pointer;
  transition: all 0.25s;
  aspect-ratio: 16 / 9;
}
.banner-uploader-dragzone:hover {
  border-color: #17a2b8;
  background-color: #f4fbfd;
}
</style>
